<app-simple-block-result
  [question]="question"
  [options]="question.block.buttons"
>
</app-simple-block-result>
